import { Box, Stack, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-premium';
import { GuestJourneyBenchmarkMetric } from 'api/reports-service/guest-journey-reports.types';
import IncDataGrid from 'components/inc-data-grid/inc-data-grid.component';

export type BenchmarksSectionGridProps = {
  /** Section heading rendered above the grid (e.g. "Engagement"). */
  title: string;
  /** Shared column defs — the same array is passed to every section so the
   * stacked grids stay column-aligned. */
  columns: GridColDef<GuestJourneyBenchmarkMetric>[];
  metrics: GuestJourneyBenchmarkMetric[];
  loading?: boolean;
  'data-testid'?: string;
};

/**
 * One benchmark section rendered as a self-contained IncDataGrid (matching the
 * other Guest Journey tables — movement, details, retention). The grid is
 * static: no sorting, no column menu, no pagination — metric order is the
 * BE-supplied order. Auto row height accommodates the two-line metric cell.
 */
const BenchmarksSectionGrid = ({
  title,
  columns,
  metrics,
  loading,
  'data-testid': dataTestId,
}: BenchmarksSectionGridProps) => (
  <Stack data-testid={dataTestId}>
    <Typography
      variant="h2"
      data-testid={dataTestId ? `${dataTestId}.Header` : undefined}
    >
      {title}
    </Typography>
    <Box>
      <IncDataGrid
        data-testid={dataTestId ? `${dataTestId}.Grid` : undefined}
        columns={columns}
        rows={metrics}
        loading={loading}
        getRowId={row => row.metricName}
        getRowHeight={() => 'auto'}
        disableColumnReorder
        disableColumnMenu
        disableRowSelectionOnClick
        autoHeight
        hideFooter
        BoxProps={{ pt: 0 }}
      />
    </Box>
  </Stack>
);

export default BenchmarksSectionGrid;
